import type { CSSProperties } from 'react';

const STAMP_FONT_FAMILY = "'Special Elite', 'Courier New', monospace";

export const stampWrapperStyle: CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
};

export const stampBoxStyle = (color: string): CSSProperties => ({
  border: `3px solid ${color}`,
  color,
  borderRadius: 10,
  padding: '5px 30px',
  minWidth: 140,
  textAlign: 'center',
  boxShadow: '0 0 4px 0 rgba(155, 155, 155, 1)',
  fontFamily: STAMP_FONT_FAMILY,
  fontSize: 30,
  letterSpacing: 1,
  backgroundColor: 'white',
});

export const stackedCardStyle = (
  depth: number,
  zIndex: number
): CSSProperties => ({
  transform: `translateY(-${depth * 16}px) scale(${1 - depth * 0.05})`,
  transformOrigin: 'top center',
  zIndex,
});

export const topCardBaseStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  cursor: 'grab',
};
